import { gql } from '@apollo/client';

// NOTE: staff fields are inlined (no fragment) because the staff object's
// GraphQL type isn't a stable named type we can pin a fragment to.

export const GET_VENDOR_STAFF = gql`
  query GetVendorStaff($vendorId: String!) {
    getVendorStaff(vendorId: $vendorId) {
      success
      message
      staff {
        id
        ownerVendorId
        userId
        name
        phone
        businessName
        staffType
        privileges
        createdAt
      }
    }
  }
`;

export const ADD_STAFF_TO_VENDOR = gql`
  mutation AddStaffToVendor($vendorId: String!, $phone: String!, $name: String!) {
    addStaffToVendor(vendorId: $vendorId, phone: $phone, name: $name) {
      success
      message
      staff {
        id
        ownerVendorId
        userId
        name
        phone
        businessName
        staffType
        privileges
        createdAt
      }
    }
  }
`;

export const REMOVE_STAFF_FROM_VENDOR = gql`
  mutation RemoveStaffFromVendor($staffVendorId: String!) {
    removeStaffFromVendor(staffVendorId: $staffVendorId) {
      success
      message
      staffVendorId
    }
  }
`;
